import React from 'react';
import { Paper, Typography } from '@mui/material';

const ResumeInfo = ({ resume }) => {
  if (!resume) {
    return null;
  }

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom>Resume Information</Typography>
      <Typography>ID: {resume.id}</Typography>
      {/* Add other resume fields as needed */}
    </Paper>
  );
};

export default ResumeInfo; 